import { ROUTES } from './routes'

/**
 * `/_/downsell/offer/{token}`: the e-mail link of a last-chance offer (F-39).
 * Public, no session. Links already sent with `/oferta/` or `/offer/` are
 * redirected here (`routes.js`).
 */
export const OFFER_PATH_PREFIX = ROUTES.downsellOffer

export const isOfferPath = (path: string): boolean => path.startsWith(OFFER_PATH_PREFIX)
